import { useEffect } from 'react';
import { DatePicker, Form, Input, Modal } from 'antd';
import { useUpdateChildInformedConsentMutation } from '@/services/child-api';
import Select from '@/components/select';
import { dateToDayjs } from '@/utils';
import moment from 'moment';

const statusData = [
  { code: 'no', name: 'No' },
  { code: 'unknown', name: 'Unknown' },
  { code: 'yes', name: 'Yes' },
];

const EditModal = ({ childId, item, refetch, onClose }) => {
  const [updateInformedConsent, { isLoading }] = useUpdateChildInformedConsentMutation();
  const [form] = Form.useForm();

  useEffect(() => {
    if (item) {
      setTimeout(() => {
        form.resetFields();
      });
    }
  }, [item, form]);

  const onFinish = async (values) => {
    try {
      await updateInformedConsent({
        childId,
        id: item.childInformedConsentId,
        body: {
          ActualModifyDate: values.actualModifyDate.toISOString(),
          notes: values.notes,
          status: { code: values.status.code },
          type: { id: item.type.id },
        },
      }).unwrap();

      refetch();
      onClose();
    } catch (err) {}
  };

  return (
    <Modal
      title="Edit Informed Consent"
      open={!!item}
      okText="Save"
      confirmLoading={isLoading}
      onOk={() => form.submit()}
      onCancel={onClose}
    >
      <Form
        layout="vertical"
        form={form}
        initialValues={{
          ...item,
          actualModifyDate: dateToDayjs(item?.actualModifyDate),
        }}
        onFinish={onFinish}
      >
        <Form.Item name="actualModifyDate" label="ActualModifyDate" rules={[{ required: true }]}>
          <DatePicker
            format="MM/DD/YYYY"
            onBlur={(e) => {
              const inputVal = e.target.value;
              const validDate = moment(inputVal, ['M/D/YYYY', 'MM/DD/YYYY'], true);
              if (validDate.isValid()) {
                form.setFieldsValue({
                  actualModifyDate: validDate,
                });
              } else {
                form.setFieldsValue({
                  actualModifyDate: null,
                });
              }
            }}
          />
        </Form.Item>
        <Form.Item name={['status', 'code']} label="Status">
          <Select options={statusData} valueName="code" />
        </Form.Item>
        {item?.type.code === 'ict-oth-act' && (
          <Form.Item
            name="notes"
            label="Note"
            rules={item?.type.code === 'ict-oth-act' ? [{ required: true, message: 'Note is required' }] : []}
          >
            <Input.TextArea autoSize={{ minRows: 3 }} />
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};

export default EditModal;
